import {
    VisitRequestTableRowFragment,
    VisitTableRowFragment,
} from '@/components/bulkQueue/tables/queries.gql.types';
import { MapFriendlyVisit } from '@/components/mapping/VisitsMap/VisitsMap.types';
import moment from 'moment-timezone';

export const visitOrVisitRequestTableRowFragmentToMapFriendlyVisits = (
    rows: (VisitRequestTableRowFragment | VisitTableRowFragment)[],
): MapFriendlyVisit[] => {
    return rows.flatMap((visitOrVisitRequest) => {
        if (visitOrVisitRequest.__typename === 'VisitRequest') {
            return [];
        }
        return (visitOrVisitRequest.appointments ?? []).map((appointment) => {
            return {
                uuid: visitOrVisitRequest.id,
                qhp: appointment.clinician
                    ? {
                          uuid: appointment.clinician.id,
                          name: `${appointment.clinician.firstName} ${appointment.clinician.lastName}`,
                      }
                    : undefined,
                modality: appointment.modality,
                lat: visitOrVisitRequest.address.coordinates?.latitude ?? null,
                lng: visitOrVisitRequest.address.coordinates?.longitude ?? null,
                datetime: visitOrVisitRequest.startDatetime
                    ? moment(visitOrVisitRequest.startDatetime).tz(visitOrVisitRequest.timezone)
                    : null,
                patientName: visitOrVisitRequest.patient.fullName,
                addressLine1: visitOrVisitRequest.address.line1,
                addressLine2: visitOrVisitRequest.address.line2,
                // Phone isn't fetched by the bulk-queue query, so it's omitted here.
                services: appointment.services.map((service) => service.name),
            };
        });
    });
};
